<!-- 服务管理-导师辅导-组件级 -->
<template>
  <div class='service'>
    <div class='service-top'>
      <ul class='clearfix'>
        <li :class="[currTab === item.id ? 'active' : '', item.show ? '' : 'hide', 'fl']"
            v-for='item in tabList'
            :key='item.id'
            @click="tabBar(item)">{{item.name}}</li>
      </ul>
    </div>
    <div class='service-con-wrap'>
      <div class='service-con'
           v-if='currTab === "waiting" && notStartList.length > 0'>
        <ul class='waiting-list'>
          <li v-for='(item, index) in notStartList'
              :key='index'>
            <div class='waiting-left'>
              <div class='waiting-month'>{{item.month ? `${Number(item.month)}月` : ''}}</div>
              <div class='waiting-day'>{{item.day}}</div>
            </div>
            <div class='waiting-right'>
              <h4 class='waiting-right-title'>导师：{{item.mentorType && new Map(mentorRoleEnMap).get(item.mentorType)}} - {{item.mentorType && new Map(mentorRoleCnMap).get(item.mentorType)}} - {{item.mentorName}}</h4>
              <div class='waiting-item-wrap'>
                <div class='waiting-item'>预约时间：{{item.menteeResultTimeStr}}（{{item.menteeZone && new Map(zoneCnMap2).get(item.menteeZone)}}）</div>
                <div class='waiting-item'>模块：{{item.module && new Map(packageModule).get(item.module)}}</div>
                <div class='waiting-item'>预计时间：{{item.predictTime}}mins</div>
                <div class='waiting-item'>讨论主题：{{item.title}}</div>
                <div class='waiting-item'>其他信息：{{item.otherMsg}}</div>
              </div>
              <div class='waiting-oper'>
                <a href='javascript: void(0);'
                   @click="goChat(item)">进入聊天室</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!--预约-等待导师确认列表-->
      <div class='service-con'
           v-if='currTab === "unconfirmMentor" && uncomfirmMentorList.length > 0'>
        <div class='unconfirm-title'>
          <p>导师确认时间前可以撤销预约，如要撤销请联系你的CD。</p>
        </div>
        <ul class='unconfirm-list'>
          <li v-for='(item, index) in uncomfirmMentorList'
              :key='index'>
            <div class='unconfirm-left-wrap'>
              <!--预约-等待导师确认列表 由该状态下track（导师返回时间段，等待学生确认）跟createTrack（学生第一次发起预约的时间段）数据一样，并且返回数据引用问题-->
              <div class='waiting-left'
                   v-if='item.createTrack && item.createTrack.content && item.createTrack.content.length > 0'>
                <div class='waiting-month'>{{ operData(item.createTrack.content[0].minTimeStr)[0] ? `${Number(operData(item.createTrack.content[0].minTimeStr)[0])}月` : ''}}</div>
                <div class='waiting-day'>{{operData(item.createTrack.content[0].minTimeStr)[1]}}</div>
              </div>
            </div>
            <div class='unconfirm-right'>
              <h4 class='unconfirm-right-title'>导师：{{item.mentorType && new Map(mentorRoleEnMap).get(item.mentorType)}} - {{item.mentorType && new Map(mentorRoleCnMap).get(item.mentorType)}} - {{item.mentorName}}</h4>
              <div class='unconfirm-item-wrap'>
                <div class='unconfirm-item'>预约时间：（{{item.menteeZone && new Map(zoneCnMap2).get(item.menteeZone)}}）</div>
                <div v-if='item.createTrack && item.createTrack.content && item.createTrack.content.length > 0'>
                  <div class='unconfirm-item'
                       v-for='(time, index) in item.createTrack.content'
                       :key='index'>{{time.minTimeStr}} - {{time.maxTimeStr}}</div>
                </div>
                <div class='unconfirm-item'>模块：{{item.module && new Map(packageModule).get(item.module)}}</div>
                <div class='unconfirm-item'>预计时间：{{item.predictTime}}mins</div>
                <div class='unconfirm-item'>讨论主题：{{item.title}}</div>
                <div class='unconfirm-item'>其他信息：{{item.otherMsg}}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!--预约-等待学员确认列表-->
      <div class='service-con'
           v-if='currTab === "unconfirmMentee" && uncomfirmMenteeList.length > 0'>
        <div class='unconfirm-title'>
          <p>你的预约时间和导师的可用时间不十分匹配，导师提供了3个他认为合适的时间，请你根据实际情况进行确认。若你选择撤销本次预约，那么你需要重新预约导师。</p>
        </div>
        <ul class='unconfirm-list'>
          <li v-for='(item, index) in uncomfirmMenteeList'
              :key='index'>
            <div class='unconfirm-left-wrap'>
              <div class='waiting-left'
                   v-if='item.createTrack && item.createTrack.content && item.createTrack.content.length > 0'>
                <div class='waiting-month'>{{ operData(item.createTrack.content[0].minTimeStr)[0] ? `${Number(operData(item.createTrack.content[0].minTimeStr)[0])}月` : ''}}</div>
                <div class='waiting-day'>{{operData(item.createTrack.content[0].minTimeStr)[1]}}</div>
              </div>
            </div>
            <div class='unconfirm-right'>
              <h4 class='unconfirm-right-title'>导师：{{item.mentorType && new Map(mentorRoleEnMap).get(item.mentorType)}} - {{item.mentorType && new Map(mentorRoleCnMap).get(item.mentorType)}} - {{item.mentorName}}</h4>
              <div class='unconfirm-item-wrap'>
                <div class='unconfirm-item'>预约时间：{{item.menteeResultTimeStr}}（{{item.menteeZone && new Map(zoneCnMap2).get(item.menteeZone)}}）</div>
                <div v-if='item.createTrack && item.createTrack.content && item.createTrack.content.length > 0'>
                  <div class='unconfirm-item'
                       v-for='(time, index) in item.createTrack.content'
                       :key='index'>{{time.minTimeStr}} - {{time.maxTimeStr}}</div>
                </div>
                <div class='unconfirm-item'>模块：{{item.module && new Map(packageModule).get(item.module)}}</div>
                <!-- <div class='unconfirm-item'>预计时间：{{item.predictTime}}mins</div>
                <div class='unconfirm-item'>讨论主题：{{item.title}}</div>
                <div class='unconfirm-item'>其他信息：{{item.otherMsg}}</div> -->
              </div>
              <div v-if='comfirmMenteeModal'>
                <serviceGuidenceMenteeModal :currMentor='item'
                                            :isShow='comfirmMenteeModal'
                                            @appointModalOk='handleMenteeOk'
                                            @closeModal='closeMenteeModal' />
              </div>
              <div class='unconfirm-oper'>
                <a href='javascript:void(0)'
                   @click="goConfirmMentee">确认预约</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class='service-con'
           v-if='currTab === "complete" && finishList.length > 0'>
        <ul class='waiting-list'>
          <li v-for='(item, index) in finishList'
              :key='index'>
            <div class='waiting-left'>
              <div class='waiting-month'>{{item.month ? `${Number(item.month)}月` : ''}}</div>
              <div class='waiting-day'>{{item.day}}</div>
            </div>
            <div class='waiting-right'>
              <h4 class='waiting-right-title'>导师：{{item.mentorType && new Map(mentorRoleEnMap).get(item.mentorType)}} - {{item.mentorType && new Map(mentorRoleCnMap).get(item.mentorType)}} - {{item.mentorName}}</h4>
              <div class='waiting-item-wrap'>
                <div class='waiting-item'>预约时间：{{item.menteeResultTimeStr}}（{{item.menteeZone && new Map(zoneCnMap2).get(item.menteeZone)}}）</div>
                <div class='waiting-item'>模块：{{item.module && new Map(packageModule).get(item.module)}}</div>
                <div class='waiting-item'>实际时长：{{item.timeSpent && `${item.timeSpent}mins`}}</div>
                <div class='waiting-item'>导师反馈：{{item.details}}</div>
                <!-- <div class='waiting-item'>您对导师的评价：您还未对导师进行评价</div>
                <div class='waiting-item'>评价详情：您还未对导师进行评价</div> -->
              </div>
              <!-- <div class='waiting-oper'>
                <a href='javascript: void(0);'
                   @click="goRate(item)">评价</a>
              </div> -->
            </div>
          </li>
        </ul>
      </div>
      <div class='service-con'
           v-if='currTab === "unconfirm" && uncomfirmList.length > 0'>
        <div class='unconfirm-title'>
          <h4>EM</h4>
          <h5>请从以下Essay Mentor中选择一位进行确认</h5>
          <p>再来人根据您的情况为您匹配了以下导师，如您觉得合适，请点击“确认导师”按钮进行确认。</p>
          <!--<p>若您觉得不合适，那么请点击“重新分配”按钮，再来人会重新为您匹配导师。</p>-->
        </div>
        <ul class='unconfirm-list'>
          <li v-for='(item, index) in uncomfirmList'
              :key='index'>
            <div class='unconfirm-left-wrap'>
              <div class='unconfirm-left'>
                <img v-if="item.avaurl"
                     :src='item.avaurl' />
                <img v-else
                     src='https://res.zailairen.com/tech/msp/mentor-avatar.svg' />
                <p class='mentor-type'>Essay Mentor-文笔导师</p>
                <p class='mentor-name'>{{item.mentorName}}</p>
              </div>
            </div>
            <div class='confirm-right'>
              <div class='unconfirm-item-wrap'>
                <div class='unconfirm-item'>Undergrad School：{{item.ugdSchool}}</div>
                <div class='unconfirm-item'>Undergrad College/Faculty：{{item.ugdCollege}}</div>
                <div class='unconfirm-item'>Undergrad Major：{{item.ugdMajor}}</div>
                <div class='unconfirm-item'>Graduate School：{{item.graduateSchool}}</div>
                <div class='unconfirm-item'>Graduate Major：{{item.graduateMajor}}</div>
                <div class='unconfirm-item'>Degree：{{item.mentorDegree ? new Map(degreeMap).get(item.mentorDegree) : ''}}</div>
              </div>
              <div class='unconfirm-oper'>
                <a href='javascript: void(0);'
                   @click="confirmMentor(item)">确认导师</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <p class='no-data'
       v-if='currTab === "unconfirm" && uncomfirmList.length === 0'>暂无待确认导师。</p>
    <p class='no-data'
       v-if='currTab === "unconfirmMentor" && uncomfirmMentorList.length === 0'>暂无预约等待导师确认。</p>
    <p class='no-data'
       v-if='currTab === "unconfirmMentee" && uncomfirmMenteeList.length === 0'>暂无待确认学员。</p>
    <p class='no-data'
       v-if='currTab === "waiting" && notStartList.length === 0'>你还没有预约导师或者你的预约还未经过导师确认。</p>
    <p class='no-data'
       v-if='currTab === "complete" && finishList.length === 0'>你还没有已经完成的预约信息。</p>
    <confirm-modal :isShow='confirmMdal'
                   :modalTitle='confirmTitle'
                   :modalContent='confirmContent'
                   :isLoading='hasComfirm'
                   defaultWidth='480px'
                   @confirmModalOk='confirmMentorOk'
                   @closeModal='handleCloseModal' />
  </div>
</template>

<script>
import confirmModal from '../../components/modal/confirm-modal'
import serviceGuidenceMenteeModal from './service-guidance-mentee-modal'
import defaultMentor from '@/assets/undergraduate/images/default_mentor.png'
import warning from '@/assets/undergraduate/images/icon_nopass.png'
import serviceService from '@/api/undergraduate/service'
import { mentorRoleEnMap, mentorRoleCnMap, zoneCnMap2, packageModule, degreeMap } from '../constantsEnum'
import dayjs from 'dayjs'
export default {
  name: '',
  components: {
    confirmModal,
    serviceGuidenceMenteeModal
  },
  data () {
    return {
      // 导师临时头像
      defaultMentor,
      // 提示图标
      warning,
      // 学历映射
      degreeMap,
      // 导师角色映射
      mentorRoleEnMap,
      mentorRoleCnMap,
      // 时区映射
      zoneCnMap2,
      // 套餐模块映射
      packageModule,
      // 头部页签
      tabList: [
        {
          id: 'waiting',
          name: '预约-未开始',
          show: true
        },
        {
          id: 'unconfirmMentor',
          name: '预约-等待导师确认',
          show: false
        },
        {
          id: 'unconfirmMentee',
          name: '预约-等待学员确认',
          show: false
        },
        {
          id: 'complete',
          name: '预约-已完成',
          show: true
        },
        {
          id: 'unconfirm',
          name: '待确认导师',
          show: false
        }
      ],
      // 当前页签位置
      currTab: 'waiting',
      // 导师确认弹窗
      confirmMdal: false,
      confirmContent: '是否确认匹配该导师？',
      confirmTitle: '导师匹配确认',
      // 导师待确认ID
      unconfirmId: -1,
      // 导师待确认列表
      uncomfirmList: [],
      // 预约-等待导师确认列表
      uncomfirmMentorList: [],
      // 预约-等待学员确认列表
      uncomfirmMenteeList: [],
      // 未开始列表
      notStartList: [],
      // 已完成列表
      finishList: [],
      // 当前导师
      currMentor: {},
      // loading-确认导师-避免重复提交
      hasComfirm: false,
      // 学员确认预约弹窗标识
      comfirmMenteeModal: false
    }
  },
  computed: {},
  mounted () {
    this.getUncomfirmList()
    this.getNotStartedList()
    this.getFinishList()
    this.getAppointComfirmMentorList()
    this.getAppointComfirmMenteeList()
  },
  methods: {
    // 获取日期字符串的年和月
    operData (str) {
      if (str) {
        let data = str.split(' ')
        let dataDate = data[0].split('-')
        return [dataDate[0], dataDate[1]]
      }
      return { year: '', month: '' }
    },
    // 获取待确认导师列表
    getUncomfirmList () {
      serviceService.appointUncomfirmList().then(res => {
        if (res.data.model) {
          this.unconfirmId = res.data.model.id
          this.uncomfirmList = res.data.model.mentors
          // 处理Tab页
          let idx = this.tabList.findIndex(item => item.id === 'unconfirm')
          if (this.uncomfirmList.length > 0) {
            this.tabList[idx].show = true
          } else {
            this.tabList[idx].show = false
          }
        } else {
          this.unconfirmId = ''
          this.uncomfirmList = []
        }
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 获取未开始列表
    getNotStartedList () {
      serviceService.appointNotStartedList().then(res => {
        let list = res.data.model
        let temp = []
        if (list.length > 0) {
          list.map(item => {
            temp.push({ ...item, month: item.menteeResultTimeStr ? dayjs(item.menteeResultTimeStr).$M + 1 : '', day: dayjs(item.menteeResultTimeStr).$D })
            return item
          })
        }
        this.notStartList = temp
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 获取预约-等待导师确认列表
    getAppointComfirmMentorList () {
      serviceService.appointComfirmMentorList().then(res => {
        if (res.data.model) {
          this.uncomfirmMentorList = res.data.model
          // 处理Tab页
          let idx = this.tabList.findIndex(item => item.id === 'unconfirmMentor')
          if (this.uncomfirmMentorList.length > 0) {
            this.tabList[idx].show = true
          } else {
            this.tabList[idx].show = false
          }
        } else {
          this.uncomfirmMentorList = []
        }
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 获取预约-等待学员确认列表
    getAppointComfirmMenteeList () {
      serviceService.appointComfirmMenteeList().then(res => {
        if (res.data.model) {
          this.uncomfirmMenteeList = res.data.model
          // 处理Tab页
          let idx = this.tabList.findIndex(item => item.id === 'unconfirmMentee')
          if (this.uncomfirmMenteeList.length > 0) {
            this.tabList[idx].show = true
          } else {
            this.tabList[idx].show = false
          }
        } else {
          this.uncomfirmMenteeList = []
        }
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },

    // 获取已完成列表
    getFinishList () {
      serviceService.appointFinishList().then(res => {
        let list = res.data.model
        let temp = []
        if (list.length > 0) {
          list.map(item => {
            temp.push({ ...item, month: item.menteeResultTimeStr ? dayjs(item.menteeResultTimeStr).$M + 1 : '', day: dayjs(item.menteeResultTimeStr).$D })
            return item
          })
        }
        this.finishList = temp
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 切换页签
    tabBar (item) {
      this.currTab = item.id
    },
    // 确认导师-按钮点击
    confirmMentor (item) {
      this.currMentor = item
      this.confirmMdal = true
    },
    // 确认导师弹窗-关闭操作
    handleCloseModal () {
      this.confirmMdal = false
    },
    // 确认导师弹窗-确认操作
    confirmMentorOk () {
      this.hasComfirm = true
      let data = {
        id: this.unconfirmId,
        mentorId: this.currMentor.mentorId
      }
      serviceService.appointUncomfirmSub(data).then(res => {
        this.hasComfirm = false
        this.confirmMdal = false
        // 调用接口
        this.$ugd_message('操作成功', 'success')
        this.getUncomfirmList()
      }).catch(error => {
        this.hasComfirm = false
        this.$ugd_message(error.message, 'error')
      })
      this.confirmMdal = false
    },
    // 进入聊天室-按钮点击
    goChat (item) {
      window.open(item.zoom)
    },
    // 评价-按钮点击
    goRate (item) {

    },
    // 确认预约-按钮点击
    goConfirmMentee () {
      this.comfirmMenteeModal = true
    },
    // 预约-等待学员确认-确认操作
    handleMenteeOk (data) {
      this.comfirmMenteeModal = false
      // 调用接口
      this.getUncomfirmList()
      this.getNotStartedList()
      this.getFinishList()
      this.getAppointComfirmMentorList()
      this.getAppointComfirmMenteeList()
      if (!data.cancel) {
        this.currTab = 'waiting'
      }
    },
    // 预约-等待学员确认-取消操作
    closeMenteeModal () {
      this.comfirmMenteeModal = false
    }
  }
}
</script>
<style lang='less' scoped>
img {
  display: block;
  border: none;
}
.clearfix {
  *zoom: 1;
  &::after {
    content: "";
    display: block;
    clear: both;
  }
  .fl {
    float: left;
  }
}
.service {
  padding-top: 40px;
  padding-left: 20px;
  .service-top {
    li {
      width: 136px;
      height: 36px;
      background: rgb(220, 232, 254);
      border-radius: 8px 8px 0 0;
      border-radius: 8px 8px 0px 0px;
      margin-right: 6px;
      cursor: pointer;
      font-size: 14px;
      color: #323c47;
      letter-spacing: 0;
      text-align: center;
      line-height: 36px;
      &.active {
        background: #fff;
      }
      &.hide {
        display: none;
      }
    }
  }
  .service-con-wrap {
    background: #fff;
    .service-con {
      padding-left: 40px;
      background: #fff;
      padding-bottom: 20px;
      .unconfirm-title {
        padding: 20px 300px 20px 20px;
        h4 {
          padding: 20px 0 10px;
          font-size: 18px;
          color: #4aa6ff;
          letter-spacing: 0;
        }
        h5 {
          font-size: 14px;
          color: #4aa6ff;
          letter-spacing: 0;
          padding: 10px 0;
        }
        p {
          font-size: 14px;
          color: #667483;
          letter-spacing: 0;
        }
      }
      .unconfirm-list {
        > li {
          display: flex;
          padding: 30px 0;
          .unconfirm-left-wrap {
            padding: 0 20px;
            flex: 0 0 116px;
            .waiting-left {
              flex: 0 0 176px;
              width: 176px;
              height: 210px;
              background: #f6f8fa;
              border-radius: 8px;
              border-radius: 8px;
              padding: 30px;
              color: rgb(74, 166, 255);
              .waiting-month {
                font-size: 20px;
                letter-spacing: 0;
                text-align: center;
                line-height: 25px;
              }
              .waiting-day {
                font-size: 80px;
                letter-spacing: 0;
                text-align: center;
                line-height: 112px;
              }
            }
          }
          .unconfirm-right {
            flex: 1;
            padding: 0 20px 20px;
            .unconfirm-right-title {
              font-size: 16px;
              color: #323c47;
              letter-spacing: 0;
              padding-bottom: 10px;
            }
            .exchange-wrap {
              padding-top: 20px;
              &:hover .exchange-time {
                display: block;
              }
              &:hover .left-trangle {
                display: block;
              }
              a {
                display: inline-block;
                vertical-align: middle;
                position: relative;
                img {
                  display: block;
                  width: 22px;
                  height: 22px;
                  border-radius: 22px;
                }
              }
              .exchange-time {
                position: absolute;
                left: 40px;
                top: -40px;
                color: #667483;
                font-size: 14px;
                font-weight: normal;
                width: 360px;
                background: #fff;
                box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
                padding: 10px;
                border-radius: 5px;
                z-index: 3;
                display: none;
                .exchange-time-item {
                  line-height: 24px;
                }
              }
              .left-trangle {
                position: absolute;
                top: 0;
                left: 30px;
                width: 16px;
                height: 16px;
                z-index: 2;
                display: none;
                .trangle {
                  width: 16px;
                  height: 16px;
                  background: #fff;
                  box-shadow: -1px 1px 3px rgba(0, 0, 0, 0.2);
                  transform: rotate(45deg);
                }
              }
            }
            .unconfirm-item {
              font-size: 14px;
              color: #667483;
              letter-spacing: 0;
              line-height: 24px;
            }
            .radio-group {
              img {
                display: inline-block;
                width: 16px;
                height: 16px;
              }
              .text {
                margin-left: 20px;
              }
            }
            .unconfirm-oper {
              padding-top: 20px;
              a {
                display: block;
                width: 96px;
                height: 32px;
                background-image: linear-gradient(
                  12deg,
                  #4aa6ff 0%,
                  #4980fd 100%
                );
                border-radius: 8px;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 0;
                text-align: center;
                line-height: 32px;
              }
              button {
                display: block;
                width: 96px;
                height: 32px;
                background-image: linear-gradient(
                  12deg,
                  #4aa6ff 0%,
                  #4980fd 100%
                );
                border-radius: 8px;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 0;
                text-align: center;
              }
            }
          }
          .confirm-right {
            flex: 1;
            .unconfirm-item {
              font-size: 12px;
              color: #667483;
              letter-spacing: 0;
              text-align: justify;
              line-height: 20px;
            }
            .unconfirm-oper {
              padding-top: 20px;
              a {
                display: block;
                width: 96px;
                height: 32px;
                background-image: linear-gradient(
                  12deg,
                  #4aa6ff 0%,
                  #4980fd 100%
                );
                border-radius: 8px;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 0;
                text-align: center;
                line-height: 32px;
              }
            }
          }
        }
      }
      .waiting-list {
        li {
          padding: 30px 20px;
          display: flex;
          .waiting-left {
            flex: 0 0 176px;
            width: 176px;
            height: 210px;
            background: #f6f8fa;
            border-radius: 8px;
            border-radius: 8px;
            padding: 30px;
            color: rgb(74, 166, 255);
            .waiting-month {
              font-size: 20px;
              letter-spacing: 0;
              text-align: center;
              line-height: 25px;
            }
            .waiting-day {
              font-size: 80px;
              letter-spacing: 0;
              text-align: center;
              line-height: 112px;
            }
          }
          .waiting-right {
            flex: 1;
            padding: 0 20px 20px;
            .waiting-right-title {
              font-size: 16px;
              color: #323c47;
              letter-spacing: 0;
              padding-bottom: 10px;
            }
            .waiting-item {
              font-size: 14px;
              color: #667483;
              letter-spacing: 0;
              line-height: 24px;
            }
            .waiting-oper {
              padding-top: 20px;
              a {
                display: block;
                width: 96px;
                height: 32px;
                background-image: linear-gradient(
                  12deg,
                  #4aa6ff 0%,
                  #4980fd 100%
                );
                border-radius: 8px;
                border-radius: 8px;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 0;
                text-align: center;
                line-height: 32px;
              }
            }
          }
        }
      }
    }
  }
  .no-data {
    text-align: center;
    padding-top: 100px;
    text-align: center;
    font-size: 16px;
    color: #667483;
  }
}
</style>
